"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var __1 = require("..");
function Item(_a) {
    var Icon = _a.icon, _b = _a.appearance, appearance = _b === void 0 ? "default" : _b, title = _a.title, description = _a.description, date = _a.date, time = _a.time;
    var iconClass = React.useMemo(function () {
        return (0, classnames_1.default)("nimbus--timeline-icon", "nimbus--timeline-icon--".concat(appearance));
    }, [appearance]);
    var memorizedIcon = React.useMemo(function () {
        return Icon ? (React.createElement("div", { className: iconClass },
            React.createElement(Icon, null))) : (React.createElement("div", { className: "nimbus--timeline-no-icon" }));
    }, [Icon, iconClass]);
    var memorizedDescription = React.useMemo(function () {
        return description && (React.createElement(__1.Text, { appearance: "light", size: "caption" }, description));
    }, [description]);
    return (React.createElement("div", { className: "nimbus--timeline-item" },
        memorizedIcon,
        React.createElement("div", { className: "nimbus--timeline-item__details" },
            React.createElement("div", { className: "nimbus--timeline-item__info" },
                React.createElement(__1.Text, { size: "caption" }, title),
                memorizedDescription),
            React.createElement("div", { className: "nimbus--timeline-item__timestamp" },
                React.createElement(__1.Text, { textAlign: "right", size: "caption" }, date),
                React.createElement(__1.Text, { textAlign: "right", appearance: "light", size: "caption" }, time)))));
}
exports.default = Item;
//# sourceMappingURL=Timeline.Item.js.map